export default "__VITE_ASSET__c851344c__"